import React from "react";
import { Divider } from "@mui/material";

import { StyledGridLines } from "./styles";

const ScheduleGridLines = ({ ceiling = 125 }) => {
  const segments = ceiling / 25;
  const lineCount = segments * 2 + 1;
  const goalIndex = (ceiling - 100) / 12.5;

  const gridLines = Array.from({ length: lineCount }, (_, i) => i);

  return (
    <StyledGridLines>
      {gridLines.map((idx) => (
        <Divider
          key={idx}
          orientation="horizontal"
          flexItem
          className={idx === goalIndex ? "goal-line" : ""}
        />
      ))}
    </StyledGridLines>
  );
};

export default ScheduleGridLines;
